import Snackbar from "../../snackbar/Snackbar";
import {ErrorTranslationKey} from "../../ErrorTranslationKey";
import {t} from "../../../../../store/localization/TranslMessasge";
import DeleteConfirmationDialog from "../../../../../components/dialogs/DeleteConfirmationDialog";
import {useRef, useState} from "react";
import {AjaxError} from "rxjs/ajax";
import {StereotypeApiClient} from "../../../../../common/apis/stereotype/StereotypeApiClient";
import {StereotypesTranslationKey} from "../StereotypesTranslationKey";

export interface AttributeDefinitionDeleteDialogProps {
    open: boolean;
    stereotypeId: string;
    attributeDefinitionId: string;
    onClose: () => void;
    onDeleted: () => void;
}

export default function AttributeDefinitionDeleteDialog(props: Readonly<AttributeDefinitionDeleteDialogProps>) {
    const {open, stereotypeId, attributeDefinitionId, onClose, onDeleted} = props;

    const stereotypeApiClient = useRef(new StereotypeApiClient());
    const [deleteInProgress, setDeleteInProgress] = useState<boolean>(false);

    function deleteDefinition(stereotypeId: string, definitionId: string) {
        setDeleteInProgress(true);
        stereotypeApiClient.current.deleteAttribute(stereotypeId, definitionId)
            .then(() => {
                onDeleted();
                onClose();
                Snackbar.success(t(StereotypesTranslationKey.ATTRIBUTE_DELETED_SUCCESSFULLY));
            })
            .catch((error: AjaxError) => {
                Snackbar.error(t(ErrorTranslationKey.UNEXPECTED_ERROR_OCCURRED), error);
            })
            .finally(() => setDeleteInProgress(false));
    }

    if (!attributeDefinitionId) {
        return null;
    }

    return (
        <DeleteConfirmationDialog
            open={open}
            title={t(StereotypesTranslationKey.DELETE_ATTRIBUTE_PROMPT)}
            message={t(StereotypesTranslationKey.ATTRIBUTE_WILL_BE_DELETED)}
            deleteDisabled={deleteInProgress}
            onDelete={() => deleteDefinition(stereotypeId, attributeDefinitionId)}
            onDismiss={onClose} />
    );
}